// Filtros disponibles para el listado público de eventos. Refleja la
// respuesta de `GET /events/filters/available` del Core B2C: una
// agrupación por dimensión (cities/categories/artists/organizations)
// con `eventCount` por opción y subcategorías anidadas dentro de cada
// categoría.
import { z } from 'zod';

// Definimos el tipo a mano y luego el schema con `z.lazy` porque zod
// no puede inferir tipos recursivos sin esta indirección.
export interface EventFilterOption {
  id: string;
  displayName: string;
  eventCount: number;
  imageUrl?: string;
  subOptions?: EventFilterOption[];
}

export const EventFilterOptionSchema: z.ZodType<EventFilterOption> = z.lazy(
  () =>
    z.object({
      id: z.string(),
      displayName: z.string(),
      eventCount: z.number().int().nonnegative(),
      imageUrl: z.string().optional(),
      subOptions: z.array(EventFilterOptionSchema).optional(),
    }),
);

export const EventFiltersResponseSchema = z.object({
  cities: z.array(EventFilterOptionSchema),
  categories: z.array(EventFilterOptionSchema),
  artists: z.array(EventFilterOptionSchema),
  organizations: z.array(EventFilterOptionSchema),
});

export type EventFiltersResponse = z.infer<typeof EventFiltersResponseSchema>;
